import { ThemeUICSSObject } from '@apia/theme';
/* IMPORT HERE */

const text: ThemeUICSSObject = {
  alignItems: 'center',
  height: '100%',
  /* PREPEND HERE */
};

export default text;
